function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "none",
  rx: 4
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#6D768F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M14.565 7.418a1.43 1.43 0 011.378-.37 1.429 1.429 0 01.639 2.387l-6.808 6.809L7 17l.756-2.774 6.809-6.808z"
}));

var SvgPencil = function SvgPencil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
};

export default SvgPencil;